export default __webpack_public_path__ + "static/open-graph-67a3e3d526b031a2dfff07f53d344a05.png";